import { render, staticRenderFns } from "./InstallPwaIos.vue?vue&type=template&id=34fd021a&scoped=true"
import script from "./InstallPwaIos.vue?vue&type=script&lang=js"
export * from "./InstallPwaIos.vue?vue&type=script&lang=js"
import style0 from "./InstallPwaIos.vue?vue&type=style&index=0&id=34fd021a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd021a",
  null
  
)

export default component.exports